/* eslint-disable no-unused-vars */
(function (Drupal) {
  Drupal.behaviors.animations = {
    attach: function (context) {
      Drupal.scaleElement = function (element) {
        if (!element) return;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              element.classList.add("scale--on");
              observer.unobserve(entry.target);
            }
          });
        });

        observer.observe(element);
      };

      Drupal.showPaws = function (element) {
        if (!element) return;

        const paws = element.querySelectorAll(".paws-wrapper__paw");

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio >= 0.5) {
                const order = [1, 0, 3, 2];
                order.forEach((val, i) => {
                  setTimeout(() => {
                    paws[val].classList.add("show");
                  }, i * 500);
                });
                observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: [0.1, 0.5],
          }
        );

        observer.observe(element);
      };
    },
  };
})(Drupal);
